import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Fibonacci(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="FibonacciIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#E8D5B7" />
        {/* Golden spiral - rotated 90° left and scaled down with padding */}
        <g
          stroke="#8B6914"
          strokeWidth="1.2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="rotate(-90 14 14) translate(4 4) scale(0.7)"
        >
          <path d="M17.25 2.19a17.2 17.2 0 0 0-17.2 17.2" />
          <path d="M27.89 12.83a10.64 10.64 0 0 0-10.64-10.64" />
          <path d="M21.32 19.4a6.57 6.57 0 0 0 6.57-6.57" />
          <path d="M17.25 15.34a4.06 4.06 0 0 0 4.06 4.06" />
          <path d="M19.76 12.83a2.51 2.51 0 0 0-2.51 2.51" />
          <path d="M21.32 14.39a1.55 1.55 0 0 0-1.55-1.55" />
          <path d="M20.35 15.34a0.96 0.96 0 0 0 0.96-0.96" />
          <path d="M19.76 14.75a0.59 0.59 0 0 0 0.59 0.59" />
        </g>
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Fibonacci;
